import { ApiError } from '@discovr/common';
import { isOutreachWireError } from '@discovr/types';

/** The shared client's policy (one retry for transient errors, none for 4xx) minus retries of a contract break:
 *  an unknown outreach status is deterministic, so a retry only delays the error the operator needs to see. */
export function retryOutreachQuery(failureCount: number, error: unknown): boolean {
  if (isOutreachWireError(error)) return false;
  if (error instanceof ApiError && error.httpStatus >= 400 && error.httpStatus < 500) return false;
  return failureCount < 1;
}
